export default __webpack_public_path__ + "static/media/49-dypticbird.e919498a.png";